import { ErrorState } from 'design-system';
import { getThemeVariant, ThemeVariant } from 'services/theming';
import { extractTraceIdFromMessage } from 'utils/traceid';
import Logo from 'images/LogoColor';
import LogoFreshmark from 'images/LogoFreshmark';
import LogoVilla from 'images/LogoVilla';

const logoStyle = {
  maxHeight: 100,
  maxWidth: 130,
};

const NetworkError = ({ message }: { message?: string; error?: Error | null; componentStack?: string }) => {
  const themeVariant = getThemeVariant();

  return (
    <ErrorState
      message={message}
      traceId={message ? extractTraceIdFromMessage(message) : null}
      logo={
        <>
          {[ThemeVariant.Nile, ThemeVariant.Inputs].includes(themeVariant) && <Logo style={logoStyle} />}
          {themeVariant === ThemeVariant.FreshMark && <LogoFreshmark style={logoStyle} />}
          {themeVariant === ThemeVariant.Villa && <LogoVilla style={logoStyle} />}
        </>
      }
    />
  );
};

export default NetworkError;
